import { X } from 'react-feather';
import { Link } from 'react-router-dom';
import { Badges, H4, H5, Image, LI, P, UL } from '../../../AbstractElements';
import { messageHeaderData } from '../../../Data/HeaderData/RightHeaderData';
import { dynamicImage } from '../../../Utils';
import SvgIcon from '../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons';
import { Checkall, Message } from '../../../Utils/Constants';

export default function MessageHeader() {
    return (
        <LI className="onhover-dropdown">
            <div className="message">
                <SvgIcon iconId='Message' />
                <Badges color='secondary' pill />
            </div>
            <div className="onhover-show-div message-dropdown">
                <H4 className="f-18 mb-0 dropdown-title">{Message}</H4>
                <UL>
                    {messageHeaderData.map((data) => (
                        <LI className={`px-0 ${data.id === 1 ? 'pt-0' : ''}`} key={data.id}>
                            <div className="d-flex align-items-start">
                                <div className="message-img bg-light-primary">
                                    <Image src={dynamicImage(`user/${data.src}`)} alt="" /></div>
                                <div className="flex-grow-1">
                                    <H5 className="mb-1">
                                        <Link to={`${process.env.PUBLIC_URL}/applications/email/letter-box`}>{data.name}</Link>
                                    </H5>
                                    <P>{data.text}</P>
                                </div>
                                <div className="notification-right"><X /></div>
                            </div>
                        </LI>
                    ))}
                    <LI>
                        <Link className="f-w-700" to={`${process.env.PUBLIC_URL}/applications/email/letter-box`}>{Checkall}</Link>
                    </LI>
                </UL>
            </div>
        </LI>
    )
}